import { render, staticRenderFns } from "./under-construction.vue?vue&type=template&id=a097f942&scoped=true&"
import script from "./under-construction.vue?vue&type=script&lang=ts&"
export * from "./under-construction.vue?vue&type=script&lang=ts&"
import style0 from "./under-construction.vue?vue&type=style&index=0&id=a097f942&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a097f942",
  null
  
)

export default component.exports